import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { get_bms_global_settings } from '@/graphql/queries'

export default {
  data() {
    return {
      LicenseList: [],

    }
  },
  methods: {
    async fetchLicense() {


      try {
        const response = await client.graphql({
          query: get_bms_global_settings,
          variables: {
          
          }
        })

        let responseData = JSON.parse(response.data.get_bms_global_settings)
        console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.LicenseList = responseData.data
        } else {
          this.LicenseList = []
        }
        // console.log(this.LicenseList)

      } catch (error) {
        console.error("Error fetching categories:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.LicenseList = [];
        throw error;
      }
    },
  },
};

